import { createJSONStorage, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

import { getConvertedDateTime, getFormattedDate } from "../helpers";

const ingestData = (responseData = []) =>
  responseData.map(
    ({
      // Metadata
      transitionId, // View Proposal Form
      questionnaireId, // View Client Questionnaire - NULLABLE
      reportId, // View Output Report - NULLABLE
      insertedDate,

      // Toggle
      advisorEmail, // To check what questionnaires taht the advisor is the logged user
      requesterEmail,

      // Tabs
      sector, // Strategy Asset Group/Sector - for filtering

      // Table Columns
      account, // proposal name
      advisorName,
      updatedDate,
      strategyName,
      status: rawStatus,
    }) => {
      const status = rawStatus.toLowerCase();
      const actions = [
        { action: "proposalForm", transitionId },
        { action: "duplicate", transitionId, status },
      ];

      if (reportId) {
        actions.push({
          action: "outputReport",
          reportId,
          transitionId,
          status,
        });
      }
      if (status === "ready") {
        actions.push({
          action: "clientQuestionnaire",
          questionnaireId,
          proposalId: transitionId,
          status,
        });
      }

      return {
        // Metadata
        reportId,
        transitionId,

        // Toggle
        advisorEmail,
        requesterEmail,
        // Tabs
        sector,

        // Table Columns
        name: account,
        advisor: advisorName,

        date: getFormattedDate(new Date(updatedDate || insertedDate)),
        convertedDateTime: getConvertedDateTime(updatedDate || insertedDate),
        rawDateTime: updatedDate || insertedDate,
        strategy: strategyName,
        status: { text: rawStatus, type: status },
        actions,
      };
    }
  );

const useStore = createWithEqualityFn(
  persist(
    (set, get) => ({
      data: {
        list: [],
      },
      actions: {
        handleSetTableData: (response) => {
          const list = ingestData(response);

          set({
            data: {
              list,
            },
          });

          return list;
        },
        getProposalNavList: () => {
          return get().data.list;
        },
      },
    }),
    {
      name: "api-proposal-listing",
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
      partialize: ({ data }) => ({ data }),
    }
  )
);

export default useStore;
